import { Injectable } from "@angular/core";
import * as moment from "moment";
import { DATE_TIME_FORMAT } from "../model/commons/DateConstants";

@Injectable()
export class LoggerService {

  constructor() {}

  public info(msg): void {
      //console.log('>>> ' + new Date() + ': ' + JSON.stringify(msg));
  }

  public warn(msg): void {
    //console.warn('>>> ' + new Date() + ': ' + JSON.stringify(msg));
  }
}



// WEBPACK FOOTER //
// ./src/app/service/LoggerService.ts